// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1581":"css/app.6931","5430":"css/admin-app.6931"}[chunkId] + ".css";
};